<template lang="pug">
div
  b-card
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 対応ワーク編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトの対応ワーク編集画面
          div.form-horizontal
            .form-group
              label.col-md-12 言語
              .col-md-12
                el-select(v-model='formData.locale', disabled='')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語')
                  el-option(value='kr', label='韓国語')
            .form-group
              label.col-md-12 カテゴリー
              .col-md-12
                el-checkbox-group(v-model='formData.work_category')
                  el-checkbox(label='自動車')
                  el-checkbox(label='情報機器')
                  el-checkbox(label='150mm前後の小物立体物')
                  el-checkbox(label='200mm前後の立体物')
                  el-checkbox(label='300mm前後の大物立体物')
                  el-checkbox(label='その他')
            .form-group
              label.col-md-12 ワークNo
              .col-md-12
                el-input(v-model='formData.work_id')
            .form-group
              label.col-md-12 被塗物名
              .col-md-12
                el-input(v-model='formData.material')
            .form-group
              label.col-md-12 治具直径
              .col-md-12
                el-input(v-model='formData.caliber')
            .form-group
              label.col-md-12 サイズ
              .col-md-12
                el-input(v-model='formData.size')
            .form-group
              label.col-md-12 ワーク数
              .col-md-12
                el-input(v-model='formData.work_num')
            .form-group
              label.col-md-12 塗装時間
              .col-md-12
                el-input(v-model='formData.cost_time')
            .form-group
              label.col-md-12 1個当り塗装時間
              .col-md-12
                el-input(v-model='formData.one_cost_time')
            .form-group
              label.col-md-12 1個当り塗料使用量
              .col-md-12
                el-input(v-model='formData.use_amount')
            .form-group
              label.col-md-12 1時間当り生産量
              .col-md-12
                el-input(v-model='formData.product_amount')
            .form-group
              label.col-md-12 1時間当り塗料消費量
              .col-md-12
                el-input(v-model='formData.consumption')
            .form-group
              label.col-md-12 ピックアップ説明文
              .col-md-12
                el-input(v-model='formData.description', type='textarea', :rows='5')
            .form-group(v-if='workPhotoImageLength > 0')
              label.col-md-12 登録済み画像・動画
              .col-md-12
                el-table(:data='formData.work_photo')
                  el-table-column(label="image", width="300")
                    template(slot-scope="scope")
                      img(v-if='scope.row.file_type=="image"', :src='scope.row.image_url', height='128')
                      video(v-if='scope.row.file_type=="video"', :src='scope.row.image_url', height='128')
                  el-table-column(property='image_url', label='image_url', width='200')
                  el-table-column(label='caption')
                    template(slot-scope='scope')
                      el-input(v-model='scope.row.caption', placeholder='キャプション')
                  el-table-column(label='Operations', width='200')
                    template(slot-scope='scope')
                      el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveImgUp(scope.$index)')
                      el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveImgDown(scope.$index)')
                      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "workPhoto")') 
            .form-group(v-if='workPhotoImageLength < 5')
              span.col-md-12 画像・動画
              el-button(type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd', v-if='workPhotoImageLength + uploadedImagesLength < 5')
              .col-md-12
                el-table(:data='formData.uploadedImages')
                  el-table-column(label='image', width='300')
                    template(slot-scope='scope')
                      img(v-if='scope.row.file_type=="image"', :src='scope.row.image', height='128')
                      video(v-if='scope.row.file_type=="video"', :src='scope.row.image', height='128')
                  el-table-column(property='name', label='name', width='200')
                  el-table-column(label='caption')
                    template(slot-scope='scope')
                      el-input(v-model='scope.row.caption', placeholder='キャプション')
                  el-table-column(label='', width='200')
                    template(slot-scope='scope')
                      el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveNewImgUp(scope.$index)')
                      el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveNewImgDown(scope.$index)')
                      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "uploadedImage")') 
                input#btnFileAdd(type='file', style='visibility: hidden', @change='onFileAdd($event)')
  .card
    .col-md-12
      PublicSetting(apiname='work', :formdata='formData')

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import PublicSetting from '@/views/components/swan/common/PublicSetting'

export default {
  name: 'WorkEdit',
  data () {
    return {
      formData: {
        locale: '',
        entry_id: '',
        work_category: [],
        work_id: '',
        material: '',
        caliber: '',
        size: '',
        work_num: '',
        cost_time: '',
        one_cost_time: '',
        use_amount: '',
        product_amount: '',
        consumption: '',
        description: '',
        work_photo: [],
        uploadedImages: [],
        open_date: '',
        close_date: '',
        created_at: '',
        updated_at: '',
        mod_date: '',
        status: '',
        agree_list: [],
        agree_user: '',
        waiting: false
      }
    }
  },
  created () {
    moment.locale('ja')
    this.workPhotoImageLength = 0
    this.uploadedImagesLength = 0
    let entryId = this.$route.query.id
    let locale = this.$route.query.locale
    this.formData.entry_id = entryId
    this.formData.locale = locale
    if (entryId && locale) {
      axios({
        method: 'GET',
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/work/edit?entry_id=' + entryId + '&locale=' + locale
      })
        .then((res) => {
          if (Object.keys(res.data).length > 0) {
            let content = res.data
            if (content.work_photo) {
              this.workPhotoImageLength = content.work_photo.length
            }
            content.locale = this.$route.query.locale
            content.entry_id = this.$route.query.id
            content.one_cost_time = content.test_data.cost_time
            content.use_amount = content.test_data.use_amount
            content.product_amount = content.test_data.product_amount
            content.consumption = content.test_data.consumption
            content.created_at = moment(content.created_at).format('YYYY-MM-DD HH:mm')
            content.updated_at = moment(content.updated_at).format('YYYY-MM-DD HH:mm')
            if (content.open_at) {
              content.open_date = moment(content.open_at).format('YYYY-MM-DD')
              content.open_time = moment(content.open_at).format('HH:mm')
            } else {
              content.open_date = null
              content.open_time = null
            }
            if (content.close_at) {
              content.close_date = moment(content.close_at).format('YYYY-MM-DD')
              content.close_time = moment(content.close_at).format('HH:mm')
            } else {
              content.close_date = null
              content.close_time = null
            }
            content.uploadedImages = []
            this.formData = content
            console.log(this.formData.cost_time)
          } else {
            this.formData.entry_id = this.$route.query.id
            this.formData.locale = this.$route.query.locale
          }
        })
        .catch((error) => {
          // 暫定的に作成されていない別言語の記事作成に対応するために記事IDと言語情報を格納
          this.formData.entry_id = this.$route.query.id
          this.formData.locale = this.$route.query.locale
          console.log(error)
        })
    } else {
      // 新規はかならず日本語から入力
      this.formData.locale = 'ja'
    }
  },
  components: {
    PublicSetting
  },
  methods: {
    deleteImage (index, imageType) {
      let imageName = ''
      let imageObject
      if (imageType === 'workPhoto') {
        imageName = this.formData.work_photo[index].name !== undefined ? this.formData.work_photo[index].name : '画像'
        imageObject = this.formData.work_photo
      } else if (imageType === 'uploadedImage') {
        imageName = this.formData.uploadedImages[index].name !== undefined ? this.formData.uploadedImages[index].name : '画像'
        imageObject = this.formData.uploadedImages
      }
      this.$confirm(imageName + 'を削除しますか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        imageObject.splice(index, 1)
        if (imageType === 'workPhoto') {
          this.workPhotoImageLength--
        } else if (imageType === 'uploadedImage') {
          this.uploadedImagesLength--
        }
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    moveImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formData.work_photo.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formData.work_photo[orgIndex])
        this.formData.work_photo = tmp
      }
    },
    moveImgDown (orgIndex) {
      if (orgIndex < this.formData.work_photo.length) {
        let target = orgIndex + 1
        let tmp = this.formData.work_photo.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formData.work_photo[orgIndex])
        this.formData.work_photo = tmp
      }
    },
    moveNewImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formData.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formData.uploadedImages[orgIndex])
        this.formData.uploadedImages = tmp
      }
    },
    moveNewImgDown (orgIndex) {
      if (orgIndex < this.formData.uploadedImages.length) {
        let target = orgIndex + 1
        let tmp = this.formData.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formData.uploadedImages[orgIndex])
        this.formData.uploadedImages = tmp
      }
    },
    onBtnFileAdd (e) {
      document.getElementById('btnFileAdd').click()
    },
    onFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      if (files[0].type.match(/image/i) || files[0].type.match(/video/i)) {
        let fileType = files[0].type.match(/image/i) ? 'image' : 'video'
        let reader = new FileReader()
        reader.onload = (r) => {
          this.formData.uploadedImages.push({ name: files[0].name, image: r.target.result, caption: '', file_type: fileType })
        }
        this.uploadedImagesLength++
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
*:focus {
  outline: 0
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/work/edit.vue